module.exports = __webpack_public_path__ + "static/media/ber.06d265e2.svg";